export { default } from './HtmlTemplateFacts';
